/**
 * Format a maker/employee name for display on the Projects page.
 * Converts "Lastname, Firstname" to "Firstname Lastname"; otherwise returns the name as-is.
 */
export function formatMakerDisplayName(name: string | null): string {
  if (name == null || name.trim() === "") return "";
  const trimmed = name.trim();
  const commaIndex = trimmed.indexOf(", ");
  if (commaIndex === -1) return trimmed;
  const last = trimmed.slice(0, commaIndex).trim();
  const first = trimmed.slice(commaIndex + 2).trim();
  if (!first) return last;
  return `${first} ${last}`;
}

export interface EmployeeName {
  name: string | null;
  nickname?: string | null;
}

/** Return the app-managed nickname when present, otherwise the canonical source name. */
export function getEmployeeDisplayName(employee: EmployeeName): string {
  const nickname = employee.nickname?.trim();
  if (nickname) return nickname;
  return employee.name?.trim() ?? "";
}

/**
 * Format a canonical Bamboo "Last, First" name for UI display while leaving a
 * user-entered nickname exactly as it was entered.
 */
export function formatEmployeeDisplayName(employee: EmployeeName): string {
  const nickname = employee.nickname?.trim();
  if (nickname) return nickname;
  return formatMakerDisplayName(employee.name);
}
